import React, { useEffect, useRef, useState } from 'react';
import './style.scss'; // import the SCSS

const DonationForm = ({ scriptUrl, isVisible, onClose }) => {
  const containerRef = useRef(null);
  const wrapperRef = useRef(null);
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    if (scriptLoaded || !containerRef.current) return; // prevent multiple injections

    const script = document.createElement('script');
    script.src =
      scriptUrl ||
      'https://secure.fundraisingbox.com/app/paymentJS?hash=j2tsr1k6gxico4iu';
    script.async = true;
    script.onload = () => setScriptLoaded(true);

    containerRef.current.appendChild(script);
  }, [scriptLoaded, scriptUrl]);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isVisible) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isVisible, onClose]);

  return (
    <div
      id="donation-overlay"
      className={`donation-overlay ${scriptLoaded ? 'loaded' : ''} ${isVisible ? 'visible' : ''}`}
    >
      <div className="donation-form-wrapper" ref={wrapperRef}>
        <button className="donation-close-btn" onClick={onClose}>
          ×
        </button>
        <div ref={containerRef} id="fbIframeDiv" />
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.fundraisingbox.com/?utm_source=donation_form"
        >
          {/*eslint-disable-next-line no-restricted-syntax */}
          <img
            className="donation-logo"
            src="https://secure.fundraisingbox.com/images/FundraisingBox-Logo-Widget.png"
            alt="FundraisingBox Logo"
          />
        </a>
      </div>
    </div>
  );
};

export default DonationForm;
